module.exports = __webpack_public_path__ + "static/media/Flashbet_logo.53fc6df3.svg";